import { CampusIdContext } from 'components/Common/PageDataContext';
import { apiEndpoint } from "helpers/url_helper";
import jwt from "jsonwebtoken";

import {useEffect,useState} from 'react';
import { useContext } from 'react';
const CampusList = props => {
  const [error, setError] = useState(null);
  //const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  //const [vehicleCountNo, setvehicleCountNo] = useState([]);
  //const [selectedCampusval, setSelected] = useState('');
  const { selectedCampusval, setCampusValue } = useContext(CampusIdContext);
  const handleCampusChange = event => {
    //console.log('Label 👉️', event.target.selectedOptions[0].label);
    //console.log(event.target.value);
    setCampusValue(event.target.value);
   props.setCampusValue(event.target.value);
//console.log(selectedCampusval)
//console.log(event.target.value)

  };

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  useEffect(() => {
   // fetch(apiEndpoint+"/GetCampusList?intUserID="+ JSON.parse(sessionStorage.getItem("UserID"))+"")
   // UserValidated
   fetch(apiEndpoint+"/GetCampusList",
   {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "strToken": sessionStorage.getItem("Clear_AuthUser"),
    })
  })
      .then(res => res.json())
      .then(
        (result) => {
        
        if(result.CampusList != undefined){
          if(JSON.parse(result.CampusList).length > 0){
            //console.log(JSON.parse(result.Locations));
            setItems(JSON.parse(result.CampusList));
            //console.log(JSON.parse(result.CampusList)[0])
            setCampusValue(JSON.parse(result.CampusList)[0].CampusID)
            //props.setCampusValue(JSON.parse(result.CampusList)[0])
          }
        }
          
          
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
         // setIsLoaded(true);
          setError(error);
        }
      )
  }, [])

  if (error) {
    return <div>Error: {error.message}</div>;
   } //else if (!isLoaded) {
  //   return <div>Loading...</div>;
  //} 
  else {
    return (
        <div>
            <select value={selectedCampusval} onChange={handleCampusChange} className="btn btn-primary dropdown-toggle">
              {
                 items.map(item => (
                 <option value={item.CampusID}>{item.CampusName}</option>
                 ))}
            </select>
        </div>
    );
  }
}


export default CampusList
